import type { RudderAnalytics } from '@rudderstack/analytics-js';

import { RudderTyper } from './webapp';

const noop = () => undefined;

/**
 * The SDK snippet in index.html leaves `window.rudderanalytics` undefined when no
 * write key is configured, and the generated client calls `analytics.*` without
 * guarding, so the resolver substitutes a stub that swallows every call.
 */
const absentAnalytics = new Proxy({} as RudderAnalytics, { get: () => noop });

/**
 * Late binding is handled by the generated client: it re-invokes this resolver on
 * every call, so the preloader-to-real-SDK swap the snippet performs is picked up
 * automatically. Constructing it with an instance instead would pin whatever sat on
 * `window` at import time and silently drop every event fired after the SDK loads.
 */
export const webapp = new RudderTyper(
  () => (window.rudderanalytics ?? absentAnalytics) as RudderAnalytics,
);
